/**
 * Alert email CTA → dashboard deep link.
 *
 * Emails currently use https://live.sentrykit.com/alerts?type=content (generic list).
 * Preferred CTA: /alerts?type=content&id={watchdog_id} which this app maps to
 * /issues?category=productDetailsRecentChange&alertId={watchdog_id} and scrolls
 * to that row.
 */

import { watchdogTypeFromApi } from './watchdogSummaryApi.js'

/** `type` query values used in alert emails / notification payloads → Issues sidebar category. */
var ALERT_EMAIL_TYPE_TO_CATEGORY = {
  content: 'productDetailsRecentChange',
  content_change: 'productDetailsRecentChange',
  content_changed: 'productDetailsRecentChange',
  product_details: 'productDetailsRecentChange',
  product_details_recent_change: 'productDetailsRecentChange',
  productdetailsrecentchange: 'productDetailsRecentChange',
  buybox: 'lostBuybox',
  lost_buybox: 'lostBuybox',
  buybox_lost: 'lostBuybox',
  hijacker: 'numberOfSellers',
  number_of_sellers: 'numberOfSellers',
  price: 'price',
  price_change: 'price',
  inventory: 'inventory',
  inventory_change: 'inventory',
  fbm_inventory: 'fbmInventory',
  sales: 'salesDrop',
  sales_drop: 'salesDrop',
  sales_volume: 'salesDrop',
  listing_suspended: 'listingSuspended',
  search_ban: 'searchBan',
  image_missing: 'imageMissing',
  category: 'productCategoryRecentChange',
  product_category_recent_change: 'productCategoryRecentChange',
  parent_product_change: 'parentProductChange',
  adult_classification: 'adultClassification'
}

export function categoryFromAlertEmailType (type) {
  if (type == null || type === '') return null
  var raw = Array.isArray(type) ? type[0] : type
  var s = String(raw).trim()
  if (!s) return null
  var lower = s.toLowerCase().replace(/-/g, '_')
  if (ALERT_EMAIL_TYPE_TO_CATEGORY[lower]) return ALERT_EMAIL_TYPE_TO_CATEGORY[lower]
  if (ALERT_EMAIL_TYPE_TO_CATEGORY[lower.replace(/_/g, '')]) {
    return ALERT_EMAIL_TYPE_TO_CATEGORY[lower.replace(/_/g, '')]
  }
  var fromApi = watchdogTypeFromApi(lower)
  return fromApi || null
}

export function alertIdFromQuery (query) {
  if (!query || typeof query !== 'object') return ''
  var raw = query.alertId != null ? query.alertId
    : query.id != null ? query.id
      : query.watchDogId != null ? query.watchDogId
        : query.watchdog_id != null ? query.watchdog_id
          : ''
  if (Array.isArray(raw)) raw = raw[0]
  var s = raw != null ? String(raw).trim() : ''
  return s
}

export function itemMatchesAlertId (item, alertId) {
  if (!item || !alertId) return false
  var t = String(alertId)
  if (item.watchDogId != null && String(item.watchDogId) === t) return true
  if (item.watchDogItemId != null && String(item.watchDogItemId) === t) return true
  return false
}

/**
 * Map `/alerts?...` (email CTA) onto `/issues?...`.
 * @param {object} query
 * @returns {{ path: string, query: object }}
 */
export function issuesLocationFromAlertsEmailQuery (query) {
  var src = query && typeof query === 'object' ? query : {}
  var next = {}
  Object.keys(src).forEach(function (k) {
    if (k === 'type' || k === 'id' || k === 'watchDogId' || k === 'watchdog_id') return
    if (src[k] != null && src[k] !== '') next[k] = src[k]
  })

  var category = src.category
  if (!category && src.type != null && src.type !== '') {
    category = categoryFromAlertEmailType(src.type)
  }
  if (category) next.category = category

  var alertId = alertIdFromQuery(src)
  if (alertId) next.alertId = alertId

  return { path: '/issues', query: next }
}



// WEBPACK FOOTER //
// ./src/utils/alertEmailDeepLink.js